import React, { useEffect, useContext } from 'react';
import { useParams } from 'react-router';

import {
    LinearProgress,
    Container    
} from '@material-ui/core';

import { RolesProvider, RolesContext } from './RolesContext';
import { NavContext } from '../../../contexts';

import {
    RoleAssigmentForm
} from './components';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    progress: {
        marginBottom: theme.spacing(2)
    }
}));

const PageContent = () => {
    const classes = useStyles();
    
    const { 
        addBreadcrumbToken 
    } = useContext(NavContext);
        
    const { 
        state,                
        isLoadingRole,
        getRoleAsync,
        isLoadingUser,
        getUserAsync,
        isAddingInRole,
        isUpdatingInRole,
    } = useContext(RolesContext);

    const {
        role
    } = state;

    const { roleId } = useParams();
    useEffect(() => {           
        getRoleAsync(roleId);   
    }, [roleId])

    const { userKey } = useParams();
    useEffect(() => {
        addBreadcrumbToken(userKey ? "Edit User" : "Add User")
        if(userKey) {
            getUserAsync(userKey);
        }
    }, [userKey]);

    return (
        <>
            {(isLoadingRole || isLoadingUser || isAddingInRole || isUpdatingInRole) &&
                <LinearProgress color="primary" className={classes.progress} />
            }
            {role && !isLoadingUser &&
                <Container maxWidth="lg">
                    <RoleAssigmentForm editMode={userKey !== undefined} />
                </Container>       
            }
        </>
    );
}

export const UserInRolePage = () => {
    return (
        <RolesProvider>
            <PageContent />
        </RolesProvider>
    );
}